import {
  PathStepType,
  TraverserStepType,
  FilterType,
  DeleteItemResult,
  RemovedItemResult,
  QueryTypes,
  ValidBusinessObject,
  PossibleBusinessObject,
  ValidBusinessObjectList,
  NodeEdgemapperLike,
} from '../datastoreProxy'

import { MapLike } from '../core'
import { NativeAttributeValue } from '@aws-sdk/util-dynamodb'

type Key = Record<string, NativeAttributeValue>

export const isTypeQueryBody = (something: any): something is TypeQueryBody => (something as TypeQueryBody).type === QueryTypes.searchByType

export type MObject = { [k: string]: ValidBusinessObject } | [MObject]

export type ListItemsData = {
  Items: ValidBusinessObject[]
}

export type SingleItemData = { item: ValidBusinessObject }

export type SimpleStringList = string[]

export type ActionObjectList = { action: string; type: string; id: string }[]

export type UserAPIGatewayResult<T> = {
  err: Error | null
  data: T
}

export type UserAPIGatewayGetQuery = string | {}

export type UserAPIGatewayGetEvent = {
  path: {
    type: string
    id: string
  }
  query: UserAPIGatewayGetQuery
}

export type UserAPIGatewayBatchGetEvent = {
  body: ValidBusinessObject[]
}

export type UserAPIGatewayResponse<T> = {
  statusCode: number
  headers: {
    'Access-Control-Allow-Credentials': boolean
    'Access-Control-Allow-Origin': string
  }
  isBase64Encoded: boolean
  body: UserAPIGatewayResult<T>
}

export type UserAPIGatewayQueryRequestEvent<T> = {
  body: T
}

export type TraverserQueryPathBody = {
  type: string
  simpleTypePath: PathStepType[] | string[] | TraverserStepType[]

  items: ValidBusinessObject[]
  normalize?: boolean
}

export type DBQueryBody = {
  type: string
  items: ValidBusinessObject[]
  indexName: string
  hashKeyName: string
  filter: FilterType
}

export type DBQueryBodyOptional = DBQueryBody & {
  limit: number | undefined
  scanForward: boolean
  exclusiveStartKey: Key | undefined
}

export type TypeQueryBody = Partial<DBQueryBodyOptional> & {
  contextObject?: ValidBusinessObject
  includeContextLinkedItems?: boolean
}

export type UserAPIGatewaySaveRequestEvent = {
  path: {
    type: string
  }
  query: UserAPIGatewayGetQuery
  body: PossibleBusinessObject
}

export type UserAPIGatewayDeleteRequestEvent = {
  path: {
    type: string
  }
  query: UserAPIGatewayGetQuery
  body: PossibleBusinessObject
}

export type UserAPIGatewayLinkRequestEvent = {
  path: {
    type: string
  }
  query: UserAPIGatewayGetQuery
  body: {
    objectA: ValidBusinessObject
    objectB: ValidBusinessObject
    edgeTypeId?: string
    edgeAttributes?: MapLike<any>
  }
}

export type UserAPIGatewayUnLinkRequestEvent = {
  path: {
    type: string
  }
  query: UserAPIGatewayGetQuery
  body: {
    objectA: ValidBusinessObject
    objectB: ValidBusinessObject
    edgeTypeId?: string
    edgeAttributes?: MapLike<any>
  }
}

export type LinkItemsResponseDataType = [
  Source: ValidBusinessObject | undefined,
  Edge: ValidBusinessObject | undefined,
  Target: ValidBusinessObject | undefined,
]

export type LinkItemsResposeErrorType = { message: string; zombieA: ValidBusinessObject; zombieB: ValidBusinessObject }

export type GetEntityContextInput = {
  entities: ValidBusinessObjectList
  includeCustomerGroups: boolean
  includeDeviceConfigs: boolean
}

export type GetEntityContextOutput = {
  nodeEdgeMapper: NodeEdgemapperLike<ValidBusinessObject>
}

export type GetDeviceContextInput = {
  device: ValidBusinessObject
}

export type GetDeviceContextOutput = {
  nodeEdgeMapper: NodeEdgemapperLike<ValidBusinessObject>
}
